import React from "react";

function ProductSwapLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="20"
      viewBox="0 0 10 20"
      fill="none"
    >
      <path
        d="M2 3C1.175 3 0.5 3.675 0.5 4.5C0.5 5.325 1.175 6 2 6C2.825 6 3.5 5.325 3.5 4.5C3.5 3.675 2.825 3 2 3ZM2 14C1.175 14 0.5 14.675 0.5 15.5C0.5 16.325 1.175 17 2 17C2.825 17 3.5 16.325 3.5 15.5C3.5 14.675 2.825 14 2 14ZM2 8.5C1.175 8.5 0.5 9.175 0.5 10C0.5 10.825 1.175 11.5 2 11.5C2.825 11.5 3.5 10.825 3.5 10C3.5 9.175 2.825 8.5 2 8.5Z"
        fill="#6D758E"
      />
      <path
        d="M8 3C7.175 3 6.5 3.675 6.5 4.5C6.5 5.325 7.175 6 8 6C8.825 6 9.5 5.325 9.5 4.5C9.5 3.675 8.825 3 8 3ZM8 14C7.175 14 6.5 14.675 6.5 15.5C6.5 16.325 7.175 17 8 17C8.825 17 9.5 16.325 9.5 15.5C9.5 14.675 8.825 14 8 14ZM8 8.5C7.175 8.5 6.5 9.175 6.5 10C6.5 10.825 7.175 11.5 8 11.5C8.825 11.5 9.5 10.825 9.5 10C9.5 9.175 8.825 8.5 8 8.5Z"
        fill="#6D758E"
      />
    </svg>
  );
}

export default ProductSwapLogo;
